import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { StaticContentClient } from 'utils';
import LanguagesContext from 'services/context/languagesContext';
import { Layout } from '.';

const LoadLayoutData = () => {
  const { bu, lang, section } = useParams();
  const [drawerData, setDrawerData] = useState(null);
  const [selectedItemName, setSelectedItemName] = useState(null);
  const [languageOptions, setLanguageOptions] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [drawerItems, languageOptions] = await Promise.all([
          StaticContentClient.getInitialData({
            lang,
            businessUnit: bu
          }),
          StaticContentClient.getLanguages()
        ]);
        const content = drawerItems.getItems();
        if (content.length > 0 && content[0]?.name) {
          const { name: firstItemName } = content[0];
          setSelectedItemName(firstItemName);
        }
        if (languageOptions.isNotEmpty()) {
          setLanguageOptions(languageOptions.getData());
        }
        setDrawerData(content);
      } catch (error) {
        // TODO handle error on prod
        console.error(
          'Something went wrong with fetching of menu content',
          error
        );
      }
    };
    fetchData();
  }, [bu, lang]);

  return drawerData !== null ? (
    <LanguagesContext.Provider
      value={{
        languageOptions
      }}
    >
      <Layout
        menuContent={drawerData}
        selectedItemName={section || selectedItemName}
      />
    </LanguagesContext.Provider>
  ) : null;
};

export default LoadLayoutData;
